import { render } from "./heads.vue?vue&type=template&id=6fd044ca&scoped=true"
import script from "./heads.vue?vue&type=script&lang=js"
export * from "./heads.vue?vue&type=script&lang=js"

import "./heads.vue?vue&type=style&index=0&id=6fd044ca&scoped=true&lang=css"

import exportComponent from "/home/smallred/20250930/inrunonline-website-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd044ca"]])

export default __exports__